export default {
  namespaced: true,

  state: {
    currentLocale: localStorage.getItem('userLocale') || 'en'
  },

  mutations: {
    SET_LOCALE(state, locale) {
      state.currentLocale = locale
      localStorage.setItem('userLocale', locale)
    }
  },

  actions: {
    SET_LOCALE({ commit }, locale) {
      commit('SET_LOCALE', locale)
    }
  },

  getters: {
    currentLocale: state => state.currentLocale
  }
}
